'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Error$PvpcontrollerWeb = require("./Error.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var LoadMore$PvpcontrollerWeb = require("./LoadMore.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var ChangeLogEntry$PvpcontrollerWeb = require("./ChangeLogEntry.js");

function fakeTable(offset) {
  return Curry._1(Css.style, {
              hd: offset !== undefined ? Css.marginTop(Css.px(offset)) : Css.marginTop(Css.zero),
              tl: {
                hd: Css.width({
                      NAME: "percent",
                      VAL: 100.0
                    }),
                tl: {
                  hd: Css.position(Css.relative),
                  tl: /* [] */0
                }
              }
            });
}

var loadingFake = Curry._1(Css.style, {
      hd: Css.position(Css.absolute),
      tl: {
        hd: Css.top(Css.zero),
        tl: {
          hd: Css.bottom(Css.zero),
          tl: {
            hd: Css.margin(Css.auto),
            tl: /* [] */0
          }
        }
      }
    });

function renderChanges(changes, simplified) {
  if (changes.length > 0) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, Belt_Array.mapWithIndex(changes, (function (i, change) {
                          var alt = i % 2 === 0;
                          return React.createElement(ChangeLogEntry$PvpcontrollerWeb.make, ChangeLogEntry$PvpcontrollerWeb.makeProps(alt, change, simplified, undefined, String(i), undefined));
                        }))));
  } else {
    return React.createElement("h3", {
                className: Theme$PvpcontrollerWeb.h3
              }, "Nothing to show");
  }
}

function Changelog(Props) {
  var getChangelog = Props.getChangelog;
  var simplifiedOpt = Props.simplified;
  var state = Props.state;
  var setState = Props.setState;
  var changelogChunkSizeOpt = Props.changelogChunkSize;
  var renderTable = Props.renderTable;
  var fakeTableOffset = Props.fakeTableOffset;
  var simplified = simplifiedOpt !== undefined ? simplifiedOpt : false;
  var changelogChunkSize = changelogChunkSizeOpt !== undefined ? changelogChunkSizeOpt : 5;
  React.useEffect((function () {
          if (state === 0) {
            return Curry._3(getChangelog, 0, changelogChunkSize, (function (result) {
                          if (result.TAG === /* Ok */0) {
                            var match = result._0;
                            var totalSize = match.totalSize;
                            var changes = match.changes;
                            return Curry._1(setState, (function (_previousState) {
                                          return /* Changes */{
                                                  _0: changes,
                                                  _1: totalSize
                                                };
                                        }));
                          }
                          var err = result._0;
                          if (err.RE_EXN_ID === "Match_failure") {
                            var match$1 = err._1;
                            Debugging$PvpcontrollerWeb.messageWithData("Changelog-PvpcontrollerWeb" + (":getChangelog Could not destructure change. Failed at " + match$1[0] + ":L" + match$1[1].toString() + "_C" + match$1[2].toString()), {
                                  tags: (function (prim) {
                                      return {};
                                    }),
                                  extra: err
                                });
                          } else {
                            Debugging$PvpcontrollerWeb.messageWithData("Changelog-PvpcontrollerWeb:getChangelog Could not get changelog.", {
                                  tags: (function (prim) {
                                      return {};
                                    }),
                                  extra: err
                                });
                          }
                          return Curry._1(setState, (function (_previousState) {
                                        return /* LoadingFailed */1;
                                      }));
                        }));
          }
          
        }), [state]);
  if (typeof state === "number") {
    if (state !== 0) {
      return React.createElement(Error$PvpcontrollerWeb.make, Error$PvpcontrollerWeb.makeProps(undefined, undefined));
    } else {
      var fakeRows = Belt_Array.makeBy(changelogChunkSize, (function (i) {
              return i;
            }));
      return React.createElement("div", {
                  className: fakeTable(fakeTableOffset)
                }, Belt_Array.mapWithIndex(fakeRows, (function (i, param) {
                        var alt = i % 2 === 0;
                        return React.createElement(ChangeLogEntry$PvpcontrollerWeb.Fake.make, ChangeLogEntry$PvpcontrollerWeb.Fake.makeProps(alt, String(i), undefined));
                      })), React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, undefined, undefined, changelogChunkSize > 1 ? 50 : 25, undefined, loadingFake, undefined, undefined)));
    }
  }
  var changes = state._0;
  if (changes.length === state._1) {
    if (renderTable !== undefined) {
      return Curry._2(renderTable, changes, simplified);
    } else {
      return renderChanges(changes, simplified);
    }
  } else {
    return React.createElement(React.Fragment, undefined, renderTable !== undefined ? Curry._2(renderTable, changes, simplified) : renderChanges(changes, simplified), React.createElement(LoadMore$PvpcontrollerWeb.make, LoadMore$PvpcontrollerWeb.makeProps((function (param) {
                          if (param.TAG === /* Ok */0) {
                            var match = param._0;
                            var totalSize = match.totalSize;
                            var changes = match.changes;
                            return Curry._1(setState, (function (previousState) {
                                          if (typeof previousState === "number") {
                                            return previousState;
                                          } else {
                                            return /* Changes */{
                                                    _0: previousState._0.concat(changes),
                                                    _1: totalSize
                                                  };
                                          }
                                        }));
                          }
                          var err = param._0;
                          if (err.RE_EXN_ID === "Match_failure") {
                            var match$1 = err._1;
                            Debugging$PvpcontrollerWeb.messageWithData("Changelog-PvpcontrollerWeb" + (":onLoadedMore Could not destructure change. Failed at " + match$1[0] + ":L" + match$1[1].toString() + "_C" + match$1[2].toString()), {
                                  tags: (function (prim) {
                                      return {};
                                    }),
                                  extra: err
                                });
                          } else {
                            Debugging$PvpcontrollerWeb.messageWithData("Changelog-PvpcontrollerWeb:publishEditModeChange Could not get changelog.", {
                                  tags: (function (prim) {
                                      return {};
                                    }),
                                  extra: err
                                });
                          }
                          return Curry._1(setState, (function (_previousState) {
                                        return /* LoadingFailed */1;
                                      }));
                        }), (function (param) {
                          
                        }), getChangelog, changes.length, changelogChunkSize, Theme$PvpcontrollerWeb.loadMore, "loadmore", undefined)));
  }
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8) {
  var tmp = {
    getChangelog: prim0,
    state: prim2,
    setState: prim3
  };
  if (prim1 !== undefined) {
    tmp.simplified = Caml_option.valFromOption(prim1);
  }
  if (prim4 !== undefined) {
    tmp.changelogChunkSize = Caml_option.valFromOption(prim4);
  }
  if (prim5 !== undefined) {
    tmp.renderTable = Caml_option.valFromOption(prim5);
  }
  if (prim6 !== undefined) {
    tmp.fakeTableOffset = Caml_option.valFromOption(prim6);
  }
  if (prim7 !== undefined) {
    tmp.key = prim7;
  }
  return tmp;
}

var make = Changelog;

exports.makeProps = makeProps;
exports.make = make;
/* loadingFake Not a pure module */
